module.exports = __webpack_public_path__ + "img/rotate.750c1e4d.png";